import _ from "lodash";
import { AccountingEntity } from "../../../entity/AccountingEntity";
import { EmailSESService } from "../EmailSES/EmailSES";
import { Events } from "../Events/Events";
import requestContractDialogTemplate from "../../../shared/dialogs/request-contract/request-contract-dialog.html";

export class ContractPlansService {
    Events = new Events();

    constructor({ DSNDialogService, User } = {}) {
        this.DSNDialogService = DSNDialogService;
        this.AccountingEntity = {};
        this.User = User;
    }

    setAccountingEntity(accountingData) {
        this.AccountingEntity = new AccountingEntity(
            accountingData,
            accountingData._id
        );
    }

    requestContract($event) {
        this.Events.send(`Plano.solicitar.upgrade`);

        this.sendEmail();

        this.DSNDialogService.custom({
            targetEvent: $event,
            controller: "RequestContractDialogCtrl",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                width: "450px",
                templateHtml: requestContractDialogTemplate
            },
            after: {}
        });
    }

    sendEmail() {
        if (publicSettings.environment != "production") return;

        const templateString = this.templateEmail({
            plan: _.get(this.AccountingEntity, "props.contract"),
            hubspotId: _.get(this.AccountingEntity, "props.hubspot._id"),
            accountingCode: _.get(
                this.AccountingEntity,
                "props.superLogica._id"
            ),
            userName: this.User.profile.nickname || this.User.profile.name,
            email: this.User.username
        });

        const senderEmail = new EmailSESService();

        const subject = `Quero mudar de plano: ${_.get(
            this.AccountingEntity,
            "props.name"
        )}`;

        senderEmail.sendBulk({
            subject: subject,
            to: [
                { name: "Hadna Esteves", email: "hadna.esteves@nucont.com" },
                {
                    name: "Giovanni Gontijo",
                    email: "giovanni.gontijo@nucont.com"
                },
                {
                    name: "Matheus Queiroga",
                    email: "matheus.queiroga@nucont.com"
                },
                {
                    name: "Fernando Pinheiro",
                    email: "fernando.pinheiro@nucont.com"
                },
                { name: "Thaina Souza", email: "thaina.souza@nucont.com" },
                { name: "Vinicius", email: "vinicius@nucont.com" }
            ],
            from: {
                name: "Nucont PRO",
                email: "nanda@nucont.com"
            },
            bodyOptions: {
                reference: "ComunicacaoInterna",
                defaultParams: {
                    subject: subject,
                    templateString
                }
            }
        });
    }
    templateEmail({
        plan,
        hubspotId,
        accountingCode,
        feature,
        userName,
        email
    }) {
        return `

        <table
        style="
            font-family: Open Sans, sans-serif;
            width: 100%;
            color: #2e5573;
            font-size: 16px;
        "
    >
        <tbody>
            <tr>
                <td valign="top">
                    <table
                        cellpadding="0"
                        cellspacing="0"
                        border="0"
                        style="
                            height: 4px;
                            width: 100%;
                            background-color: #00cbd2;
                            margin-bottom: 24px;
                        "
                    >
                        <tbody>
                            <tr></tr>
                        </tbody>
                    </table>
                    <h1
                        style="
                            text-align: center;
                            font-size: 24px;
    
                            margin: 0;
    
                            font-family: Open Sans, sans-serif;
                        "
                    >
                        Solicitação de mudança do plano
                    </h1>
                    <table
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        style="
                            font-size: 0;
                            height: 30px;
                            width: 100%;
                            min-width: 100%;
                            line-height: 0;
                        "
                    >
                        <tbody>
                            <tr>
                                <td height="30">
                                    <span
                                        style="
                                            color: transparent;
                                            background: none;
                                            text-overflow: ellipsis;
                                            opacity: 0;
                                            width: 100%;
                                            min-width: 100%;
                                            height: 1;
                                            padding: 0;
                                            font-size: 0;
                                        "
                                    >
                                        &nbsp;</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <p><strong>Plano atual:</strong> ${plan}</p>
                    <p>
                        <strong>Código no Hubspot:</strong> ${hubspotId}
                    </p>
                    <p><strong>Código da Nucont:</strong> ${accountingCode}</p>
                    <p>
                        <strong>Usuário:</strong>
                        ${userName} (${email})
                    </p>
                </td>
            </tr>
        </tbody>
    </table>
    
        `;
    }
}
